var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modalAjoutProduitHM",
      attrs: {
        size: "xl",
        scrollable: "",
        title: _vm.titreModal,
        "ok-title": _vm.titreBoutonOk,
        "cancel-title": "Annuler",
        "ok-disabled":
          !_vm.ajouterOK ||
          (!_vm.produitEstModifiee && !_vm.donneeFournisseurEstModifiee),
        "no-close-on-backdrop": ""
      },
      on: {
        ok: function($event) {
          return _vm.enregistrerProduit()
        },
        show: function($event) {
          return _vm.initialiserModale()
        }
      }
    },
    [
      _c("div", { staticStyle: { display: "inline" } }, [
        _c("div", { staticClass: "container-fluid card card-body" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-6 form-group" },
              [
                _c("label", [_vm._v("Famille du produit")]),
                _c("v-select", {
                  attrs: {
                    id: "selFamille",
                    options: _vm.optionsFamilles,
                    value: "id",
                    label: "nom",
                    clearable: false
                  },
                  on: {
                    input: function($event) {
                      return _vm.selectFamilleDeProduit($event)
                    }
                  },
                  model: {
                    value: _vm.familleSelect,
                    callback: function($$v) {
                      _vm.familleSelect = $$v
                    },
                    expression: "familleSelect"
                  }
                }),
                !_vm.familleSelect ||
                (_vm.familleSelect && !_vm.familleSelect.id)
                  ? _c("div", { staticClass: "error" }, [
                      _vm._v("Ce champ est requis")
                    ])
                  : _c("div", [_vm._v(" ")])
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-6 form-group" },
              [
                _c("label", { staticClass: "push-right-2rem" }, [
                  _vm._v("Fournisseur")
                ]),
                _c(
                  "v-select",
                  {
                    attrs: {
                      disabled:
                        _vm.modifierProduit && !_vm.selectionFournisseur,
                      options: _vm.optionsFournisseurs,
                      value: "id",
                      label: "nom",
                      clearable: false
                    },
                    on: {
                      input: function($event) {
                        _vm.key++
                      }
                    },
                    model: {
                      value: _vm.donneeFournisseur.fournisseur,
                      callback: function($$v) {
                        _vm.$set(_vm.donneeFournisseur, "fournisseur", $$v)
                      },
                      expression: "donneeFournisseur.fournisseur"
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        attrs: { slot: "no-options" },
                        on: {
                          click: function($event) {
                            _vm.$refs.select.open = false
                          }
                        },
                        slot: "no-options"
                      },
                      [_vm._v(" Veuillez sélectionner une famille ... ")]
                    )
                  ]
                ),
                !_vm.donneeFournisseur.fournisseur
                  ? _c("div", { staticClass: "error" }, [
                      _vm._v("Ce champ est requis")
                    ])
                  : _c("div", [_vm._v(" ")])
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-4 form-group" },
              [
                _c("label", [_vm._v("Ingrédient")]),
                _c("RechercheCompleteProduits", {
                  ref: "refChercherIngredient",
                  attrs: {
                    disabled: _vm.rechercheIngredientDisabled,
                    chercherIngredients: true,
                    chercherProduits: true,
                    pourChoixIngredient: true,
                    afficherPrix: false,
                    initValeur: _vm.produitHM.ingredient
                      ? _vm.produitHM.ingredient.nomIngredient
                      : ""
                  },
                  on: {
                    input: function($event) {
                      _vm.key++
                    },
                    reset: function($event) {
                      return _vm.resetIngredient()
                    }
                  },
                  model: {
                    value: _vm.produitHM.ingredient,
                    callback: function($$v) {
                      _vm.$set(_vm.produitHM, "ingredient", $$v)
                    },
                    expression: "produitHM.ingredient"
                  }
                })
              ],
              1
            ),
            _c("div", { staticClass: "col-8 form-group" }, [
              _c("label", { staticClass: "push-right-2rem" }, [
                _vm._v("Désignation")
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.donneeFournisseur.description,
                    expression: "donneeFournisseur.description",
                    modifiers: { trim: true }
                  }
                ],
                staticStyle: { width: "100%" },
                attrs: {
                  type: "text",
                  title: "Description du produit pour le fournisseur"
                },
                domProps: { value: _vm.donneeFournisseur.description },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.donneeFournisseur,
                        "description",
                        $event.target.value.trim()
                      )
                    },
                    function($event) {
                      _vm.key++
                    }
                  ],
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              }),
              !_vm.donneeFournisseur.description
                ? _c("div", { staticClass: "error" }, [
                    _vm._v("Ce champ est requis")
                  ])
                : _c("div", [_vm._v(" ")])
            ])
          ]),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-3 form-group" }, [
              _c("label", [_vm._v("Marque")]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.donneeFournisseur.marque,
                    expression: "donneeFournisseur.marque",
                    modifiers: { trim: true }
                  }
                ],
                staticStyle: { width: "100%" },
                attrs: { type: "text" },
                domProps: { value: _vm.donneeFournisseur.marque },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.donneeFournisseur,
                        "marque",
                        $event.target.value.trim()
                      )
                    },
                    function($event) {
                      _vm.key++
                    }
                  ],
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              }),
              _c("div", [_vm._v(" ")])
            ]),
            _c("div", { staticClass: "col-3 form-group" }, [
              _c("label", [_vm._v("Référence")]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.donneeFournisseur.reference,
                    expression: "donneeFournisseur.reference",
                    modifiers: { trim: true }
                  }
                ],
                staticStyle: { width: "100%" },
                attrs: { type: "text" },
                domProps: { value: _vm.donneeFournisseur.reference },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.donneeFournisseur,
                        "reference",
                        $event.target.value.trim()
                      )
                    },
                    function($event) {
                      _vm.key++
                    }
                  ],
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              }),
              _c("div", [_vm._v(" ")])
            ]),
            _c(
              "div",
              { staticClass: "col-6 form-group" },
              [
                _c("label", [_vm._v("Allergènes")]),
                _c("MultiSelect", {
                  attrs: {
                    items: _vm.optionsAllergenes,
                    itemText: "valeur",
                    itemValue: "id",
                    emptyText: "Tous les allergènes ont été ajoutés"
                  },
                  on: {
                    change: function($event) {
                      _vm.key++
                    }
                  },
                  model: {
                    value: _vm.donneeFournisseur.allergenesMajeurs,
                    callback: function($$v) {
                      _vm.$set(_vm.donneeFournisseur, "allergenesMajeurs", $$v)
                    },
                    expression: "donneeFournisseur.allergenesMajeurs"
                  }
                }),
                !_vm.donneeFournisseur.allergenesMajeurs ||
                _vm.donneeFournisseur.allergenesMajeurs.length === 0
                  ? _c("div", { staticClass: "error" }, [
                      _vm._v("Ce champ est requis")
                    ])
                  : _vm.allergenesKO
                  ? _c("div", { staticClass: "error" }, [
                      _vm._v(
                        "Vous ne pouvez pas sélectionner 'Aucun Allergène' avec d'autres allergènes"
                      )
                    ])
                  : _c("div", [_vm._v(" ")])
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-4 form-group" }, [
              _c("label", [_vm._v("PCB")]),
              _c(
                "div",
                { staticClass: "flex-start" },
                [
                  _c("InputNumber", {
                    attrs: { typeFiltre: "quantite" },
                    on: {
                      input: function($event) {
                        _vm.key++
                      }
                    },
                    model: {
                      value: _vm.donneeFournisseur.pcb,
                      callback: function($$v) {
                        _vm.$set(_vm.donneeFournisseur, "pcb", $$v)
                      },
                      expression: "donneeFournisseur.pcb"
                    }
                  }),
                  _c("v-select", {
                    staticClass: "ml-1",
                    staticStyle: { width: "200px" },
                    attrs: {
                      id: "selUC",
                      options: _vm.optionsUC,
                      value: "id",
                      label: "nom",
                      clearable: false
                    },
                    on: {
                      input: function($event) {
                        _vm.selectUCDeProduit($event)
                        _vm.key++
                      }
                    },
                    model: {
                      value: _vm.ucSelect,
                      callback: function($$v) {
                        _vm.ucSelect = $$v
                      },
                      expression: "ucSelect"
                    }
                  })
                ],
                1
              ),
              !_vm.donneeFournisseur.pcb || !_vm.ucSelect.id
                ? _c("div", { staticClass: "error" }, [
                    _vm._v("Ces champs sont requis")
                  ])
                : _c("div", [_vm._v(" ")])
            ]),
            _c("div", { staticClass: "col-4 form-group" }, [
              _c("label", [_vm._v("P.U. HT")]),
              _c(
                "div",
                { staticClass: "flex-start" },
                [
                  _c("InputNumber", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: {
                          content: "Prix Unitaire (selon PCB)",
                          placement: "top"
                        },
                        expression:
                          "{ content: 'Prix Unitaire (selon PCB)', placement: 'top' }"
                      }
                    ],
                    attrs: { typeFiltre: "montant" },
                    on: {
                      input: function($event) {
                        _vm.key++
                      }
                    },
                    model: {
                      value: _vm.donneeFournisseur.pu,
                      callback: function($$v) {
                        _vm.$set(_vm.donneeFournisseur, "pu", $$v)
                      },
                      expression: "donneeFournisseur.pu"
                    }
                  }),
                  _c("div", { staticClass: "input-group-append" }, [
                    _c("span", { staticClass: "input-group-text" }, [
                      _vm._v("€" + _vm._s(this.unitePrix(1)))
                    ])
                  ])
                ],
                1
              ),
              !_vm.donneeFournisseur.pu
                ? _c("div", { staticClass: "error" }, [
                    _vm._v("Ce champ est requis")
                  ])
                : _c("div", [_vm._v(" ")])
            ]),
            _c("div", { staticClass: "col-4 form-group" }, [
              _c("label", [_vm._v("Montant HT")]),
              _c(
                "div",
                { staticClass: "flex-center-center input-group-text" },
                [_vm._v(" " + _vm._s(_vm.montantHT) + " ")]
              ),
              _c("div", [_vm._v(" ")])
            ]),
            _c("div", { staticClass: "col-1 form-group" })
          ]),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-4 form-group" }, [
              _c("label", [_vm._v("Taux TVA")]),
              _c(
                "div",
                { staticClass: "flex-start" },
                [
                  _c("v-select", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      id: "selTVA",
                      options: _vm.optionsTVA,
                      value: "id",
                      label: "nom",
                      clearable: false
                    },
                    on: {
                      input: function($event) {
                        _vm.selectTVA($event)
                        _vm.key++
                      }
                    },
                    model: {
                      value: _vm.tvaSelect,
                      callback: function($$v) {
                        _vm.tvaSelect = $$v
                      },
                      expression: "tvaSelect"
                    }
                  }),
                  _c("div", { staticClass: "input-group-append" }, [
                    _c("span", { staticClass: "input-group-text" }, [
                      _vm._v("%")
                    ])
                  ])
                ],
                1
              )
            ]),
            _c("div", { staticClass: "col-4 form-group" }, [
              _c("label", [_vm._v("P.U. TTC")]),
              _c(
                "div",
                { staticClass: "flex-center-center input-group-text" },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.puTTC) +
                      " €" +
                      _vm._s(this.unitePrix(1)) +
                      " "
                  )
                ]
              )
            ]),
            _c("div", { staticClass: "col-4 form-group" }, [
              _c("label", [_vm._v("Montant TTC")]),
              _c(
                "div",
                { staticClass: "flex-center-center input-group-text" },
                [_vm._v(" " + _vm._s(_vm.montantTTC) + " ")]
              )
            ])
          ]),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c(
                "p",
                {
                  staticStyle: { "padding-top": "15px", "font-size": "0.8em" }
                },
                [
                  _c("em", [
                    _vm._v(
                      "L’affichage des allergènes est effectué à titre informatif. Chaque utilisateur du logiciel doit vérifier par lui-même la véracité de ces informations auprès du ou des fournisseurs de denrées alimentaires concernés."
                    ),
                    _c("br"),
                    _vm._v(
                      " En cas d’erreur, l’utilisateur ne pourra pas engager la responsabilité de la société Agap’pro, éditrice du logiciel."
                    )
                  ])
                ]
              )
            ])
          ])
        ]),
        _c("div", { staticClass: "container-fluid card card-body" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 form-group" }, [
              _c("label", [_vm._v("Paramétrage pour les recettes")])
            ])
          ]),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-1 form-group" }),
            _c("div", { staticClass: "col-10 form-group" }, [
              _c("p", [_vm._v("Contenu du produit :")]),
              _vm.donneeFournisseur.pcb && _vm.ucSelect.id
                ? _c("div", { staticClass: "flex-center-center" }, [
                    _c("div", { staticClass: "input-group-prepend" }, [
                      _c("span", { staticClass: "input-group-text mr-4" }, [
                        _vm._v(
                          "Dans " +
                            _vm._s(_vm.donneeFournisseur.pcb) +
                            " " +
                            _vm._s(
                              _vm.plurielUC(
                                _vm.donneeFournisseur.pcb,
                                _vm.produitHM.uc
                              )
                            ) +
                            " je vais avoir "
                        )
                      ])
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.donneeFournisseur.nbPCE,
                          expression: "donneeFournisseur.nbPCE"
                        }
                      ],
                      staticClass: "saisieRepartition form-control flex-end",
                      staticStyle: { width: "100px" },
                      attrs: { type: "number" },
                      domProps: { value: _vm.donneeFournisseur.nbPCE },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.donneeFournisseur,
                              "nbPCE",
                              $event.target.value
                            )
                          },
                          function($event) {
                            _vm.key++
                          }
                        ]
                      }
                    }),
                    _c("div", { staticClass: "input-group-append" }, [
                      _c("span", { staticClass: "input-group-text mr-4" }, [
                        _vm._v(
                          _vm._s(
                            _vm.plurielUC(
                              _vm.donneeFournisseur.nbPCE,
                              "Pièce"
                            ) + ", "
                          )
                        )
                      ])
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.donneeFournisseur.nbKg,
                          expression: "donneeFournisseur.nbKg"
                        }
                      ],
                      staticClass: "saisieRepartition form-control flex-end",
                      staticStyle: { width: "100px" },
                      attrs: { type: "number" },
                      domProps: { value: _vm.donneeFournisseur.nbKg },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.donneeFournisseur,
                              "nbKg",
                              $event.target.value
                            )
                          },
                          function($event) {
                            _vm.key++
                          }
                        ]
                      }
                    }),
                    _c("div", { staticClass: "input-group-append" }, [
                      _c("span", { staticClass: "input-group-text mr-4" }, [
                        _vm._v("Kg, ")
                      ])
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.donneeFournisseur.nbL,
                          expression: "donneeFournisseur.nbL"
                        }
                      ],
                      staticClass: "saisieRepartition form-control flex-end",
                      staticStyle: { width: "100px" },
                      attrs: { type: "number" },
                      domProps: { value: _vm.donneeFournisseur.nbL },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.donneeFournisseur,
                              "nbL",
                              $event.target.value
                            )
                          },
                          function($event) {
                            _vm.key++
                          }
                        ]
                      }
                    }),
                    _c("div", { staticClass: "input-group-append" }, [
                      _c("span", { staticClass: "input-group-text" }, [
                        _vm._v(
                          _vm._s(
                            _vm.plurielUC(_vm.donneeFournisseur.nbL, "Litre")
                          )
                        )
                      ])
                    ])
                  ])
                : _c(
                    "span",
                    { staticClass: "input-group-text flex-center-center" },
                    [_vm._v("Veuillez renseigner le PCB")]
                  ),
              _c(
                "div",
                {
                  staticClass: "flex-center-center",
                  staticStyle: { height: "50px" }
                },
                [
                  _vm.repartitionOK &&
                  _vm.donneeFournisseur.pcb && _vm.ucSelect.id
                    ? _c("div", [
                        _c("em", [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.phraseConversion(
                                  _vm.donneeFournisseur,
                                  _vm.produitHM,
                                  _vm.donneeFournisseur.pcb
                                ) || "Pas de répartition."
                              )
                            )
                          ]),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.phraseConversion(
                                  _vm.donneeFournisseur,
                                  _vm.produitHM,
                                  1.5 * _vm.donneeFournisseur.pcb
                                )
                              )
                            )
                          ])
                        ])
                      ])
                    : _vm.donneeFournisseur.pcb && _vm.ucSelect.id
                    ? _c("div", [
                        _c("em", [_c("p", [_vm._v("Pas de répartition.")])])
                      ])
                    : _vm._e()
                ]
              )
            ]),
            _c("div", { staticClass: "col-1 form-group" })
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }